import { call, fork, put, takeEvery } from 'redux-saga/effects'

import { HttpClient } from '../../../services/HttpClient'
import authorizationActions from './authorization-actions'
import { LOGIN_STATUSES } from './authorization-constants'

export function* requestMagicLink(action) {
  try {
    const { email, onSuccess } = action.payload

    const data = yield call(() => {
      return HttpClient.post('/api/public/login/magic-link', {
        body: {
          email,
        },
      })
    })

    if (data && data.message) {
      yield put(authorizationActions.requestMagicLinkFailed(data.message))
    } else {
      yield put(authorizationActions.requestMagicLinkSucceeded())

      if (onSuccess) {
        onSuccess()
      }
    }
  } catch (e) {
    yield put(authorizationActions.requestMagicLinkFailed(e.message))
  }
}

export function* verifyMagicLink(action) {
  try {
    const { token, onSuccess } = action.payload

    const data = yield call(() => {
      return HttpClient.post('/api/public/login/verify', {
        body: {
          token,
        },
      })
    })

    if (data.status === LOGIN_STATUSES.ok && data.authToken) {
      localStorage.setItem('LOGIN', data.email)

      // drop any stale stored tokens so the fresh refresh token is kept
      HttpClient.logout()
      HttpClient.login(data)
      yield put(authorizationActions.verifyMagicLinkSucceeded(data))

      if (onSuccess) {
        onSuccess()
      }
    } else {
      yield put(authorizationActions.verifyMagicLinkFailed(data.message))
    }
  } catch (e) {
    yield put(authorizationActions.verifyMagicLinkFailed(e.message))
  }
}

export function* logout(action) {
  try {
    const data = yield call(() => {
      return HttpClient.post('/api/public/logout', {
        body: {},
      })
    })

    if (data && data.message) {
      yield put(authorizationActions.logoutFailed(data.message))
    } else {
      localStorage.setItem('LOGIN', null)
      window.location.href = '/#/login'

      HttpClient.logout()
      yield put(authorizationActions.logoutSucceeded(data))
    }
  } catch (e) {
    yield put(authorizationActions.logoutFailed(e.message))
  }
}

function* requestMagicLinkSaga() {
  yield takeEvery(
    authorizationActions.actionTypes.REQUEST_MAGIC_LINK,
    requestMagicLink
  )
}

function* verifyMagicLinkSaga() {
  yield takeEvery(
    authorizationActions.actionTypes.VERIFY_MAGIC_LINK,
    verifyMagicLink
  )
}

function* logoutSaga() {
  yield takeEvery(authorizationActions.actionTypes.LOGOUT, logout)
}

export default function* authorizationSaga() {
  yield fork(requestMagicLinkSaga)
  yield fork(verifyMagicLinkSaga)
  yield fork(logoutSaga)
}
